/**
 * Check if the rich text editor content is empty.
 *
 * Note:
 * Quill outputs `<p><br></p>` (and sometimes `<div><br></div>`) when the editor is empty.
 * We handle those cases explicitly in addition to empty strings.
 */
export const isRichTextEmpty = (html: string): boolean => {
  if (!html) return true;

  const tmpElement = document.createElement("DIV");
  tmpElement.innerHTML = html;
  const textContent = (
    tmpElement.textContent ||
    tmpElement.innerText ||
    ""
  ).trim();
  tmpElement.remove();

  return !textContent;
};
